<template>
  <section>
    <div class="contacts-supply-chart">
      <div class="date-range">
        <small class="text-muted">From: {{ dataValues[0]._from }}</small>
        <small class="text-muted">To: {{ dataValues[0]._to }}</small>
      </div>
      <div class="stats">
        <div class="stat">
          <div class="avg-supply" :class="getAvgClass()">
            <p>Avg Supply</p>
            <h2>{{ dataValues[0].avg_campaign_supply }}%</h2>
          </div>
        </div>
        <div class="stat">
          <p>New Emails</p>
          <h2>{{ formatInteger(dataValues[0].total_new_emails) }}</h2>
          <span class="small"> Objective: {{ formatInteger(dataValues[0].total_obj_new_emails) }}</span>
        </div>
        <div class="stat">
          <p>Campaigns</p>
          <h2>{{ formatInteger(dataValues[0].total_accounts) }}</h2>
          <span class="small"> Avg Days Active: {{ formatInteger(dataValues[0].avg_days_campaign_active) }}</span>
        </div>
        <div class="stat">
          <p>Targets</p>
          <h2>{{ formatInteger(dataValues[0].total_targets) }}</h2>
          <span class="small"> in Salesridge: {{ formatInteger(dataValues[0].total_t_salesridge /
            dataValues[0].total_targets * 100) }}%</span>
        </div>

      </div>
      <line-chart :width="500" :height="250" :chart-data="barData" :options="barData.options" />
    </div>
  </section>
</template>

<script>
import LineChart from '@/components/Chart.vue';

export default {
  name: "ContactsSupplyChart",
  components: { LineChart },
  data() {
    return {

      //     barData: {
      //       labels: ["Percentil"],
      //       datasets: [
      //         { type: 'bar', label: "p30", backgroundColor: "#F87171", data: [5], borderRadius: 8 },
      //         { type: 'bar', label: "p40", backgroundColor: "#FDBA74", data: [30], borderRadius: 8 },
      //         { type: 'bar', label: "p50", backgroundColor: "#60A5FA", data: [50], borderRadius: 8 },
      //         { type: 'bar', label: "p60", backgroundColor: "#34D399", data: [60], borderRadius: 8 },
      //         { type: 'bar', label: "p70", backgroundColor: "#A78BFA", data: [60], borderRadius: 8 },
      //         // { type: 'line', label: "avg", backgroundColor: "#FBBF24", data: [], borderRadius: 8 },
      //       ],
      //       options: {
      //         responsive: true,
      //         title: {
      //           display: true,
      //           text: this.$t("Contact supply"),
      //         },
      //         legend: {
      //           display: false,
      //         },
      //         scales: {
      //           yAxes: [
      //             {
      //               type: "linear",
      //               id: "y1",
      //               position: "right",
      //               display: true,
      //               gridLines: {
      //                 drawOnChartArea: false,
      //               },
      //               ticks: {
      //                 beginAtZero: true,
      //               },
      //             },
      //           ],
      //           xAxes: [
      //             {
      //               stacked: false,
      //               offset: true,
      //               display: true, // asegúrate que esté habilitado

      //               ticks: {
      //                 fontColor: "#fff", // color texto
      //                 fontSize: 13,      // tamaño texto
      //                 autoSkip: false,   // muestra todos los labels
      //                 maxRotation: 0,    // no rotar
      //                 minRotation: 0,
      //                 padding: 10,       // espacio entre eje y texto
      //               },
      //               gridLines: {
      //                 display: false, // sin líneas verticales
      //                 drawBorder: true,
      //               },
      //               scaleLabel: {
      //                 display: true,
      //                 labelString: "Percentiles", // título debajo del eje X
      //                 fontColor: "#555",
      //                 fontSize: 14,
      //               },
      //             },
      //           ],
      //         },
      //       },
      //     },
      //   };
      // },

      barData: {
        labels: ["avg", "p10", "p20", "p30", "p40", "p50", "p60", "p70", "p80", "p90"], // 👈 un label por barra
        datasets: [
          // {
          //   type: "bar",
          //   label: "Contacts Supply",
          //   backgroundColor: ["#F87171", "#FDBA74", "#60A5FA", "#34D399", "#A78BFA"],
          //   data: [5, 30, 50, 60, 60], // 👈 un valor por label
          // },
        ],
        options: {
          responsive: true,
          title: {
            display: false,
            text: "Contact supply",
            fontSize: 16,
            fontColor: "#fff",
          },
          legend: {
            display: false,
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: function (tooltipItem, data) {
                const label = data.labels[tooltipItem.index]; // p30, p40, etc.
                const labelPrc = label.replace('p', ''); // extrae el número del percentil
                const value = tooltipItem.yLabel;             // valor numérico
                if (tooltipItem.index === 0) {
                  return ` Average supply: ${value}%`;  // texto personalizado para average
                }
                return ` ${labelPrc}% of the campaigns are below ${value}% of the supply.`;        // texto personalizado
              },
            },
          },
          scales: {
            xAxes: [
              {
                stacked: false,
                offset: true,
                display: true,
                ticks: {
                  fontColor: "#fff",
                  fontSize: 13,
                  autoSkip: false,
                  maxRotation: 0,
                  minRotation: 0,
                  padding: 10,

                },
                gridLines: {
                  display: false,
                },
                scaleLabel: {
                  display: true,
                  labelString: "Percentiles",
                  fontColor: "#555",
                  fontSize: 14,
                },
              },
            ],
            yAxes: [
              {
                type: "linear",
                id: "y1",
                position: "left",
                display: true,
                gridLines: {
                  display: true,        // ✅ Muestra las líneas horizontales (por defecto)
                  color: "#444",        // 🎨 Color de las líneas
                  borderDash: [5, 5],    // ← patrón de línea punteada [segmento, espacio]
                  lineWidth: 1,         // Grosor de las líneas
                  drawBorder: false,     // Dibuja la línea del borde del eje
                  drawTicks: false,     // Oculta las pequeñas marcas en el borde
                  zeroLineColor: "#000",// Línea del valor 0 (más marcada)
                },
                ticks: {
                  beginAtZero: true,
                },
                scaleLabel: {
                  display: true,
                  labelString: "Campaigns Supply (%)",
                  fontColor: "#555",
                  fontSize: 14,
                },
              },
            ],

          },
        }
      }
    }
  },
  props: { dataValues: Array },
  created() {
    let metrics = this.dataValues[0];
    const colors = [
      { max_value: 10, color: "#DC2626" },  // rojo fuerte
      { max_value: 20, color: "#F87171" },  // rojo claro
      { max_value: 30, color: "#FB923C" },  // naranja
      { max_value: 40, color: "#FDBA74" },  // naranja claro
      { max_value: 50, color: "#3B82F6" },  // azul brillante
      { max_value: 60, color: "#60A5FA" },  // azul medio
      { max_value: 70, color: "#93C5FD" },  // azul claro
      { max_value: 80, color: "#34D399" },  // verde medio
      { max_value: 90, color: "#22C55E" },  // verde
      { max_value: 100, color: "#16A34A" }, // verde intenso
    ];

    let percentiles = [10, 20, 30, 40, 50, 60, 70, 80, 90, 'avg'];

    let lastPercentileValue = 0;
    // percentiles.forEach((percentile, index) => {

    //   let key = `p${percentile}_contacts_supply`;
    //   if (percentile === 'avg') {
    //     key = 'avg_campaign_supply';
    //   }
    //   let percentileValue = metrics[key];

    //   if (percentileValue == 0) {
    //     percentileValue = 0.66; // para que se vea la barra aunque sea 0
    //   }
    //   // if (percentileValue == lastPercentileValue) {
    //   //   return;
    //   // }
    //   lastPercentileValue = percentileValue

    //   const label = percentile === 'avg' ? `avg` : `p_${percentile}`;
    //   const match = colors.find(c => percentileValue <= c.max_value);
    //   const bgColor = match && percentile !== 'avg' ? match.color : "#FBBF24"; // dorado para el average
    //   const type = percentile === 'avg' ? 'line' : 'bar';
    //   const newDataSet = { type: type, label: label, backgroundColor: bgColor, data: [percentileValue] };
    //   this.barData.datasets.push(newDataSet);

    // });

    let bgColors = [""];
    let percentilesX = ["0"];

    percentiles.forEach((percentile, index) => {

      let key = `p${percentile}_contacts_supply`;
      if (percentile === 'avg') {
        key = 'avg_campaign_supply';
      }
      let percentileValue = metrics[key];

      if (percentileValue == 0) {
        percentileValue = 0.21; // para que se vea la barra aunque sea 0
      }
      // if (percentileValue == lastPercentileValue) {
      //   return;
      // }
      lastPercentileValue = percentileValue

      const match = colors.find(c => percentileValue <= c.max_value);
      const bgColor = match && percentile !== 'avg' ? match.color : "#FBBF24"; // dorado para el average

      bgColors.push(bgColor);
      percentilesX.push(percentileValue);
    });

    const newDataSet = { type: "bar", backgroundColor: bgColors, data: percentilesX };
    this.barData.datasets.push(newDataSet);

    const avgDataSet = { type: "line", backgroundColor: "#FBBF24", data: [metrics.avg_campaign_supply], yAxisID: 'y1' };
    this.barData.datasets.push(avgDataSet);

    // datasets: [
    //   {
    //     type: "bar",
    //     label: "Contacts Supply",
    //     backgroundColor: ["#F87171", "#FDBA74", "#60A5FA", "#34D399", "#A78BFA"],
    //     data: [5, 30, 50, 60, 60], // 👈 un valor por label
    //     borderRadius: 8,
    //   },

    this.barData.options.avgLine = metrics.avg_campaign_supply;
  },
  methods: {
    formatInteger(num) {
      num = Math.floor(num);
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    getAvgClass() {
      const avg = this.dataValues[0].avg_campaign_supply;
      if (avg < 30) {
        return 'avg-alert';
      } else if (avg < 70) {
        return 'avg-regular';
      } else {
        return '';
      }
    },
  }

};
window.onload = function () {
  //w ww . java  2  s.  c om
  // Show tooltips always even the stats are zero
  Chart.pluginService.register({
    afterDraw: function (chart) {
      const avg = chart.config.options.avgLine;

      if (avg === undefined) return;

      // busca una escala Y válida
      const yScale =
        chart.scales["y1"] ||
        Object.values(chart.scales).find((s) => s.isHorizontal === false);

      if (!yScale) return; // si no hay escala Y, salimos

      const ctx = chart.chart.ctx;
      const yValue = yScale.getPixelForValue(avg);

      let color = "#31BD07"; // verde
      console.log('avg line', avg);
      if (avg < 30) {
        color = "#DD1806"; // rojo
      } else if (avg < 70) {
        color = "#FBBF24"; // amarillo
      }
      ctx.save();
      ctx.beginPath();
      ctx.moveTo(chart.chartArea.left, yValue);
      ctx.lineTo(chart.chartArea.right, yValue);
      ctx.lineWidth = 2;
      ctx.strokeStyle = color; // color dorado
      ctx.setLineDash([6, 3]); // opcional: línea discontinua
      ctx.stroke();
      ctx.restore();
    },
  });
};
</script>

<style scoped>
.contacts-supply-chart {
  max-width: 700px;
  margin: auto;
  background: #0f172a;
  color: white;
  border-radius: 16px;
  padding: 35px;
  position: relative;
}

.date-range {
  position: absolute;
  top: 6px;
  right: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  font-size: 11px;
}

.date-range .text-muted {
  color: #6b7280;
}

.stats {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}

.stat {
  text-align: center;
}

.stat p {
  font-size: 14px;
  color: #9ca3af;
}

.stat h2 {
  font-size: 28px;
  font-weight: bold;
  margin: 0;
}
.stat .avg-supply h2 {
  font-size: 48px;
  color: #31BD07;
}
.stat .avg-supply.avg-regular h2 {
  color: #FBBF24;
}
.stat .avg-supply.avg-alert h2 {
  color: #DD1806;
}

</style>
